// extracted by mini-css-extract-plugin
export default {"Logos":"Logos-module__Logos--GRmxd","Logos-logoSuite":"Logos-module__Logos-logoSuite--9ThXV","Logos-playButton":"Logos-module__Logos-playButton--Lxk1E"};